export default "__VITE_ASSET__l1C7ZxVp__"